<script lang="ts">
  import { onMount } from 'svelte';
  import type { AdPosition } from '$src/js/_types/VideoAd';
  import BaseModule from '$src/js/app/base/BaseModule';
  import Content from '$src/js/components/organisms/video-ad-top/components/Content.svelte';
  import Header from '$src/js/components/organisms/video-ad-top/components/Header.svelte';

  const { position }: { position: AdPosition } = $props();

  const SESSION_STORAGE_KEY = 'videoAdTopShown';
  let isVisible = $state(false);
  const videoAdTopData = $state(
    window.ads && !Array.isArray(window.ads) ? window.ads.siteTop?.[0] : undefined,
  );

  const sendPageView = () => {
    try {
      const formData = new FormData();
      formData.append('id', String(videoAdTopData!.id));
      formData.append('position', position);
      formData.append('site', document.documentElement.dataset.site ?? '');

      const url = BaseModule.getInstance().routing.setlanguagePathPrefix(
        `/api-simple/?module=ads&action=register-view`,
      );

      const beaconSent = navigator.sendBeacon(url, formData);

      if (!beaconSent) {
        console.warn('Failed to send adsview beacon');
      }
    } catch (error) {
      console.error('Error sending adsview:', error);
    }
  };

  onMount(() => {
    if (!videoAdTopData) {
      if (position === 'content-item-detail') {
        document.querySelector('[data-position="content-item-detail"]')?.remove();
      }
      return;
    }

    const elementId = document.documentElement.dataset.elementId;
    if (elementId && window.advertorialIds?.includes(Number(elementId))) {
      return;
    }

    if (position === 'site-top') {
      const hasBeenShown = sessionStorage.getItem(SESSION_STORAGE_KEY);

      if (hasBeenShown) {
        return;
      }

      // Hide billboard when showing video ad
      document.querySelector('.r89-desktop-billboard-atf')?.closest('.r89-placement')?.remove();
      document.querySelector('.r89-mobile-billboard-top')?.closest('.r89-placement')?.remove();

      // Set session storage item
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    }

    isVisible = true;
  });
</script>

{#if isVisible}
  <div>
    {#if position === 'site-top'}
      <Header videoAdTopData={videoAdTopData!} onSendPageView={sendPageView} />
    {:else}
      <Content videoAdTopData={videoAdTopData!} onSendPageView={sendPageView} />
    {/if}
  </div>
{/if}
